import React from "react";
import Level1 from "../../assets/Badge/L1.svg";
import Level2 from "../../assets/Badge/L2.svg";
import Level3 from "../../assets/Badge/L3.svg";
import Level4 from "../../assets/Badge/L4.svg";
import Level5 from "../../assets/Badge/L5.svg";
import Locked from "../../assets/Badge/Locked.svg";
import { getLevelFromStars } from "./utils";

type LevelBadgeProps = React.HTMLProps<HTMLDivElement> & {
  level?: number;
  stars?: number;
};

const LevelBadge = ({ level, stars, ...rest }: LevelBadgeProps) => {
  const getImage = () => {
    const l = level || getLevelFromStars(stars);
    switch (l) {
      case 1:
        return Level1;
      case 2:
        return Level2;
      case 3:
        return Level3;
      case 4:
        return Level4;
      case 5:
        return Level5;
      default:
        return Locked;
    }
  };
  return (
    <div {...rest}>
      <img src={getImage()} alt={"level"} className="level-badge-icon" />
    </div>
  );
};

export default LevelBadge;
